import clsx from 'clsx';
import React, { useContext } from 'react';
import DropdownContext from '../context';
import { setRef } from '../../../../hooks';
import * as styles from '../dropdown.styles';

/**
 * @type {typeof import('../').DropdownTrigger}
 */
const DropdownTrigger = ({ children }) => {
  const { show, isOpen, triggerRef } = useContext(DropdownContext);

  let child;
  try {
    child = React.Children.only(children);
  } catch {
    console.warn('Dropdown trigger only support a single children and cannot be a Fragment or a String');
    return children;
  }
  if (!React.isValidElement(child)) {
    return null;
  }

  return React.cloneElement(child, {
    tabIndex: child.props.tabIndex ?? '0',
    className: clsx(styles.trigger, child.props.className),
    ref: setRef(triggerRef, child.ref),
    onClick: (evt) => {
      show(evt);
      child?.props?.onClick?.(evt);
    },
    onKeyDown: (evt) => {
      if (!isOpen && ['Space', 'Enter', 'NumpadEnter'].includes(evt.code)) {
        show(evt);
        child?.props?.onClick?.(evt);
      }
      child?.props?.onKeyDown?.(evt);
    },
  });
};

if (process.env.NODE_ENV !== 'production') {
  DropdownTrigger.displayName = 'Dropdown.Trigger';
}

export default DropdownTrigger;
